import { css } from '@emotion/react';
import { colors, spacing } from '#themes/stena-recycling';

export const styles = {
  Item: ({
    itemDepth,
    expandable,
    isSelectable,
    multiple,
  }: {
    itemDepth: number;
    expandable: boolean;
    isSelectable: boolean;
    multiple: boolean;
  }) => css`
    width: 100%;
    box-sizing: border-box;
    outline: 0;
    cursor: ${expandable || isSelectable ? 'pointer' : 'default'};
    user-select: none;
    display: grid;
    gap: ${spacing.xsmall};
    align-items: center;
    grid-template-columns: ${multiple ? '1.5rem' : ''} 1fr ${expandable ? '1.5rem' : ''};
    font-size: 1rem;
    line-height: 1rem;
    padding: ${spacing.xmsmall};
    padding-left: calc(${spacing.xmsmall} + ${itemDepth} * ${spacing.xmsmall});

    &[data-disabled] {
      grid-template-columns: 1fr ${expandable ? '1.5rem' : '0'};
      font-weight: bold;
      border-bottom: 1px solid ${colors.monochrome.grey20};
    }

    &[data-highlighted] {
      z-index: 0;
      position: relative;
    }

    &[data-highlighted]::before {
      content: '';
      z-index: -1;
      position: absolute;
      inset-block: 0;
      inset-inline: 1px;
      /* border-radius: 0.25rem; */
      background-color: ${colors.background.grey};
    }
  `,
  ItemIndicator: css`
    grid-column-start: 1;
  `,
  ItemText: ({ multiple }: { multiple: boolean }) => css`
    grid-column-start: ${multiple ? 2 : 1};
    display: flex;
    flex-direction: column;

    [data-disabled] > & {
      grid-column-start: 1;
    }
  `,
};
